const initialState = {
  search: "",
  category: "all",
};

export default initialState;
